module.exports = __webpack_public_path__ + "img/8.14092738.png";